import { useState } from 'react';
import { Point } from './Point/Point';
import { Point3_1 } from './Point/Point3_part1';
import { useTranslation,Trans } from 'react-i18next';

import { GenericSlider } from "../../common/GenericSlider/GenericSlider";
import classes from './PointCarousel.module.scss';
import { CustomNextArrow, CustomPrevArrow } from '../../common/GenericSlider/SliderArrows/SliderArrows';

export const PointCarousel = () => {
  const { t } = useTranslation();
  const [currentSlide, setCurrentSlide] = useState(0);
  const totalSlides = 3;

  const customSettings = {
    infinite: false,
    centerPadding: '0',
    beforeChange: (current, next) => setCurrentSlide(next),
      nextArrow: <CustomNextArrow small hide={currentSlide === totalSlides - 1} />,
      prevArrow: <CustomPrevArrow small hide={currentSlide === 0} />,
  };


  const pointData = [
    {
      number: '01',
      title: <Trans i18nKey="about:point.01.title" components={{ 1: <br className="pconly" />, 2: <br className="sponly" /> }} />,
      description: <Trans i18nKey="about:point.01.description" components={{ 1: <br className="pconly" /> }} />
    },
    {
      number: '02',
      title: t('about:point.02.title'),
      description: <Trans i18nKey="about:point.02.description" components={{ 1: <br className="pconly" /> }} />
    },
    {
      number: '03',
      title: t('about:point.03.title'),
    }
  ];


return (
  <div className={classes.sliderWrap}>
    <GenericSlider settings={customSettings}>
      {pointData.map((point, index) => (
        index !== 2
          ? <Point key={index} {...point} />
          : <Point key={index} {...point}><Point3_1 /></Point>
      ))}
    </GenericSlider>
  </div>
);

    };